import { Fragment, useEffect } from "react";
import queryString from "query-string";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import * as actions from "./ui-interactions-loader.actions";

// Loads the company's and the signed-in user's remembered UI choices once, near
// the app root, so any component can read them straight from the store. One
// request fills both slices. Renders nothing.
const UiInteractionsLoader = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  // A ?token URL is a shared link opened without a signed-in user (UserSession
  // skips getCurrentUser for the same reason), so there is nothing to fetch.
  const { token } = queryString.parse(location.search);

  useEffect(() => {
    if (!token) {
      dispatch(actions.fetchAllUiInteractions());
    }
  }, [token]);

  return <Fragment />;
};

export default UiInteractionsLoader;
